export const KontaktniPodatkiEnum = {
  T2_SUPPORT_TEL_ST: '064 064 064',
  T2_INFO_EMAIL: 'info@t-2.net'
}



// WEBPACK FOOTER //
// ./src/assets/js/Enum/KontaktniPodatkiEnum.js